import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { AnnualRapidWithdrawModel} from "../../../models/dashboard/withdraw/withdraw";


const getAnnualRapidWithdrawals = (): Promise<Array<AnnualRapidWithdrawModel>> => {

    return adminHttpClient.get(`/api/Admin/AdminMoveMoney/get-annual-rapid-statistics`)
}
export default getAnnualRapidWithdrawals